import LocalizedStrings from 'react-localization';
import en from './en';

let strings = new LocalizedStrings({
  en,
});

export default strings;
